














































































































import { Component, Vue } from 'vue-property-decorator';
@Component({})
export default class AddFlightPriceModal extends Vue {
  dialog: boolean = true;

  passport: Date = null;
  birthday: Date = null;

  created() {}

  data() {
    return {
      range: [0, 70],

      flightClassItems: ['Economy'],
      flightClasses: [],

      flightSegmentItems: ['Y'],
      flightSegments: [],

      passengerTypeItems: ['Yetişkin', 'Çocuk', 'Bebek'],
      passengerTypes: [],

      salesChannelItems: ['Acente', 'İnternet', 'Momondo', 'Skyscanner'],
      salesChannels: [],
    };
  }

  closeDialog() {
    this.$emit('closed');
  }
}
